import { render, staticRenderFns } from "./dayHot2.vue?vue&type=template&id=d42240a8&scoped=true"
import script from "./dayHot2.vue?vue&type=script&lang=js"
export * from "./dayHot2.vue?vue&type=script&lang=js"
import style0 from "./dayHot2.vue?vue&type=style&index=0&id=d42240a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42240a8",
  null
  
)

export default component.exports